<template>
    <div class="userinfo">
        <div class="left">
            <div class="img_box" @click="goBack">
                <img class="hvr-grow" :src="userInfo.avatar" v-if="userInfo.avatar && userInfo.avatar.indexOf('http') != -1" alt="">
                <img class="hvr-grow" :src="$ImgUrl + userInfo.avatar" v-if="userInfo.avatar && userInfo.avatar.indexOf('http') == -1" alt="">
                <img class="hvr-grow" src="../../assets/static/index/default.png" v-if="!userInfo.avatar" alt="">
            </div>
            <div class="username">
                {{ userInfo.userName }}
            </div>
            <div class="dept_name">
                <span class="iconfont icon-jicengdangjian"></span>
                <span class="dept">{{ userInfo.deptName }}</span>
            </div>
            <div class="edit_btn">
                <el-button @click="editUser">编辑资料</el-button>
            </div>
        </div>
        <div class="right">

            <div class="ji_fen item">
                <div class="ji_value">
                    <span style="font-size:43px;">{{ rankInfo.integral }}</span>
                    <span>分</span>
                </div>
                <div class="my_title">
                    我的积分
                </div>
                <div class="btn_box">
                    <el-button @click="getMingXiList">积分明细 > </el-button>
                </div>
            </div>

            <div class="ji_fen item">
                <div class="ji_value">
                    <span style="font-size:43px;">{{ rankInfo.rank }}</span>
                    <!-- <span>分</span> -->
                </div>
                <div class="my_title">
                    我的排名
                </div>
                <div class="btn_box">
                    <el-button @click="showBang">排行榜 > </el-button>
                </div>
            </div>

            <div class="ji_fen item">
                <div class="ji_value">
                    <span style="font-size:43px;" class="iconfont icon-xuefen" ></span>
                    <!-- <span>分</span> -->
                </div>
                <div class="my_title">
                    我的课程
                </div>
                <div class="btn_box">
                    <el-button @click="showList">点击查看 ></el-button>
                </div>
            </div>

        </div>
            
            <!-- 积分明细dialog -->
            <el-dialog
            title="积分明细"
            :visible.sync="dialogVisible"
            width="50%"
>
            <div class="mx_list_box">
                <div class="year_chose" style="text-align:right;">
                     <el-date-picker
                        v-model="yearStr"
                        type="year"
                        placeholder="选择年">
                        </el-date-picker>
                </div>

                <el-table
                :data="MingXiList"
                style="width: 100%">
                <el-table-column
                    prop="createTime"
                    label="日期"
                    >
                </el-table-column>
                <el-table-column
                    prop="star"
                    label="星级类型"
                   >
                </el-table-column>
                <el-table-column
                    prop="integralName"
                    label="积分规则">

                     <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                    <p> {{ scope.row.integralName }}</p>
                    <div slot="reference" class="name-wrapper">
                        <el-tag size="medium" type="danger">查看积分规则</el-tag>
                    </div>
                    </el-popover>
                </template>
                </el-table-column>
                <el-table-column
                    prop="integral"
                    label="积分">
                </el-table-column>
                </el-table>

                <div class="page_box" style="text-align:right;" v-if="MingXiList && MingXiList.length">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :current-page="page"
                        :page-size="10"
                        @current-change="pageChange"
                        :total="totalPage * 10">
                        </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="closeDialog">确 定</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        props: {
            userInfo: Object,
            rankInfo: Object
        },
        data() {
            return {
                dialogVisible: false,
                page: 1,
                totalPage: 0,
                MingXiList: [],
                year: new Date().getFullYear(),
                yearStr: "",
            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        watch: {
            yearStr () {
                this.year = new Date( this.yearStr ).getFullYear()
                console.log( this.year )
                this.getMingXiList()
            }
        },
        methods: {
            // 返回个人中心
            goBack () {
                this.$router.push("/user")
            },
            // 个人信息页
            editUser () {
                this.$router.push("/editUserInfo")
            },

            // 查看课程
            showList () {
                this.$router.push("/user/mystudy")
            },

            // phb
            showBang () {
                this.$router.push("/user/jifenbang")
            },

            // 获取积分明细
            async getMingXiList () {
                let { token, page, year } = this 
                let res = await this.$axios.post("/lencon/pc/person/myIntegralList", { token, page, year })
                if ( res.data.code == 1 ) {
                    this.MingXiList = res.data.data
                    this.totalPage = res.data.totalPages
                    this.dialogVisible = true
                }
            },

            // 关闭dialog
            closeDialog () {
                this.page = 1 
                this.totalPage = 0
                this.MingXiList = []
                this.dialogVisible = false
            },

            // 页码变化
            pageChange ( page ) {
                this.page = page 
                this.getMingXiList()
            },

        },
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
    color: #fff;
    
}
.el-date-picker {
    z-index: 10000000000000000 !important;
}
</style>
<style lang="scss" scoped>
.userinfo {
    width: 1200px;
    box-sizing: border-box;
    margin: 100px auto 0 auto;
    display: flex;
    .left {
        width: 215px;       
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        position: relative;
        left: 0;
        top: 0;
        padding-top: 60px;
        height: 196px;
        .img_box {
            width:90px;
            height: 90px;
            border-radius: 50%;
            border: 2px solid #fff;
            overflow: hidden;
            position: absolute;
            left: 50%;
            top: -45px;
            margin-left: -45px;
        }
        img {
            width:90px;
            height: 90px;
            border-radius: 50%;
            // overflow: hidden;
            

        }
        .edit_btn {
            text-align: center;
            
            .el-button {
                width: 134px;
                // height: 31px;
                // line-height: 31px;
                color: #fff;
                background: rgba(255, 255, 255, 0.3);
                border-radius: 5px;
                border: none;
            }
        }
        .username {
            font-size: 22px;
            color: #fff;
            font-weight: bold;
            text-align: center;
        }
        .dept_name {
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 40px;
        }
    }
    .right {
        flex: 1;
        display: flex;
        justify-content: space-around;
        .item {
            text-align: center;
            color: #fff;
            .ji_value {
                height: 50px;
            }
            .my_title {
                line-height: 50px;
            }
            .btn_box {
                .el-button {
                    background: rgba(255, 255, 255, 0.26);
                    border-radius: 5px;
                    color: #fff;
                    border: none;
                }
            }
        }
    }
}
</style>